import React, { createContext, ComponentType, useState, useMemo } from 'react';
import axios from 'axios';
import { Localize, useTransform } from '@hilma/netina2all';

interface KitsContextProviderValue {
    selectedKits: { [key: string]: number };
    setSelectedKits: React.Dispatch<React.SetStateAction<{ [key: string]: number }>>;
    selectedHolders: number;
    setSelectedHolders: React.Dispatch<React.SetStateAction<number>>;
    getKitInfo: () => Promise<void>;
    showErr: boolean;
    kitsResponse: Localize<KitsResponse>[] | null;
    holderCheck: boolean;
    setHolderCheck: React.Dispatch<React.SetStateAction<boolean>>;
    awareCheck: boolean;
    setAwareCheck: React.Dispatch<React.SetStateAction<boolean>>;
    idOfNeedy: number | undefined;
    numOfSelectedKits: number;
}

export interface KitsResponse {
    id: number;
    name: string;
    price: number;
    donationPercent: string;
    isForNeedy: boolean;
    available: boolean;
    description?: string;
    imagePath?: string;
}

export const KitsContext = createContext<KitsContextProviderValue | null>(null)

export const KitsProvider: React.FC = ({ children }) => {

    const [selectedKits, setSelectedKits] = useState<{ [key: string]: number }>({});
    const [selectedHolders, setSelectedHolders] = useState(0);
    const [showErr, setShowErr] = useState(false);
    const [kitsResponse, setKitsResponse] = useState<Localize<KitsResponse>[] | null>(null);
    const [holderCheck, setHolderCheck] = useState(false);
    const [awareCheck, setAwareCheck] = useState(false);

    const translatedKits = useTransform<KitsResponse>(kitsResponse);

    const idOfNeedy = useMemo(() => {
        return translatedKits?.find(kit => kit.isForNeedy)?.id
    }, [translatedKits])

    const numOfSelectedKits = useMemo(() => {
        return Object.entries(selectedKits)?.filter(entry => idOfNeedy !== +entry[0]).map((e: [string, number]) => e[1]).reduce((accu, current) => accu + +current, 0) ?? 0;
    }, [selectedKits]);

    const getKitInfo = async () => {
        if (kitsResponse !== null) return;

        try {
            const res = await axios.get<Localize<KitsResponse>[]>('/api/kit/get-kits')

            setKitsResponse(res.data)

        } catch (err) {
            setShowErr(true)
        }
    }

    return (
        <KitsContext.Provider value={{ selectedKits, setSelectedKits, selectedHolders, setSelectedHolders, getKitInfo, showErr, kitsResponse, holderCheck, setHolderCheck, awareCheck, setAwareCheck, idOfNeedy, numOfSelectedKits }}>
            {children}
        </KitsContext.Provider>
    )
}